import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import { DEALER_PROPS, REVIEWS_LIST_TYPES, REVIEWS_PER_CLICK } from 'client/constants/dealer-reviews';
import { BaseReviewsList } from 'site-modules/dealerships/components/dealer-reviews-section/components/base-reviews-list/base-reviews-list';
import { CollapsibleReviewsList } from 'site-modules/dealerships/components/dealer-reviews-section/components/collapsible-reviews-list/collapsible-reviews-list';

export function ReviewsListLayout({
  allReviewsByType,
  reviewsType,
  params,
  initialCount,
  totalReviews,
  newReviewsCount,
  onMaxAmountExpanded,
  isMobile,
}) {
  const newReviews = get(allReviewsByType, 'newReviews', []);
  const oldReviews = get(allReviewsByType, 'oldReviews', []);
  const oldReviewsCount = totalReviews - newReviewsCount;

  const props = { reviewsType, params, initialCount, newOldReviewsCount: totalReviews, onMaxAmountExpanded, isMobile };

  if (newReviews.length && oldReviews.length) {
    return (
      <BaseReviewsList {...props} listType={REVIEWS_LIST_TYPES.NEW} reviews={newReviews} totalReviews={newReviewsCount}>
        <CollapsibleReviewsList
          {...props}
          initialCount={REVIEWS_PER_CLICK}
          listType={REVIEWS_LIST_TYPES.OLD}
          reviews={oldReviews}
          totalReviews={oldReviewsCount}
          newOldReviewsCount={0}
        />
      </BaseReviewsList>
    );
  }

  if (newReviews.length) {
    return (
      <BaseReviewsList
        {...props}
        listType={REVIEWS_LIST_TYPES.NEW}
        reviews={newReviews}
        totalReviews={newReviewsCount}
      />
    );
  }

  if (oldReviews.length) {
    return (
      <BaseReviewsList
        {...props}
        listType={REVIEWS_LIST_TYPES.OLD}
        reviews={oldReviews}
        totalReviews={oldReviewsCount}
      />
    );
  }

  return null;
}

ReviewsListLayout.propTypes = {
  allReviewsByType: PropTypes.shape({
    allReviews: PropTypes.arrayOf(ReviewEntities.ReviewEntity),
  }).isRequired,
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string.isRequired,
  initialCount: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired,
  newReviewsCount: PropTypes.number.isRequired,
  onMaxAmountExpanded: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
